import React, { useState } from "react";
import emailjs from "emailjs-com";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceId = "service_j834lxn"; // Replace with your EmailJS service ID
    const templateId = "template_45v3o7w"; // Replace with your EmailJS template ID
    const userId = "xFy2rc00jzGEjGFjr"; // Replace with your EmailJS user ID

    const emailData = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      reply_to: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs
      .send(serviceId, templateId, emailData, userId)
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setStatus("Message sent successfully!");
          setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
        },
        (error) => {
          console.error("FAILED...", error);
          setStatus("Failed to send message. Please try again later.");
        }
      );
  };

  return (
   <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-gray-100 to-gray-200 p-6 overflow-x-hidden">
  <h2 className="text-black text-3xl mb-10">Let's Connect</h2>

  <div className="md:w-1/2 w-full max-w-lg bg-slate-950 text-black shadow-lg rounded-lg p-8"> <h2 className="text-3xl font-bold text-center mb-6 text-white">Get In Touch</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First Name"
              required
              className="p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last Name"
              required
              className="p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              required
              className="p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone No."
              className="p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            required
            className="p-3 border rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-purple-500"
          ></textarea>
          <button
            type="submit"
            className="w-full py-3 bg-purple-700 text-white font-bold rounded-lg hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            Send
          </button>
        </form>
        {status && <p className="text-center mt-4 text-purple-700">{status}</p>}
      </div>
    </div>
  );
};

export default ContactForm;
